import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Sirve para primaria y secundaria?',
  answer: 'Sí. Está diseñado para ser adaptable por nivel, con variantes y progresión.'
}, {
  question: '¿Necesito instrumentos para usarlo?',
  answer: 'No. Incluye percusión corporal, juegos y actividades sin instrumentos. Y también opciones si tenés instrumentos.'
}, {
  question: '¿Es imprimible?',
  answer: 'Sí. Todo está listo para imprimir en formato A4.'
}, {
  question: '¿Incluye planificación anual?',
  answer: 'Sí. Incluye planificación anual sugerida, unidades, objetivos y plantillas semanales.'
}, {
  question: '¿Cómo lo descargo?',
  answer: 'Acceso inmediato al finalizar la compra.'
}, {
  question: '¿Es editable?',
  answer: 'Incluye plantillas editables cuando corresponde, además podés adaptar consignas fácilmente.'
}, {
  question: '¿Sirve si doy talleres (coro/ensamble)?',
  answer: 'Sí. Hay dinámicas para grupo, ensamble, coordinación y proyectos.'
}, {
  question: '¿Y si no me sirve?',
  answer: 'Tenés garantía editable de 7 o 14 días. Lo probás y decidís con tranquilidad.'
}];
export const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 bg-white" data-id="element-19">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-12" data-id="element-21">
          Preguntas frecuentes
        </h2>
        <div className="space-y-4" data-id="element-22">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-23">
              <button className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 focus:outline-none flex justify-between items-center transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-24">
                <span className="font-medium text-gray-900" data-id="element-25">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="h-5 w-5 text-gray-500" data-id="element-26" /> : <ChevronDown className="h-5 w-5 text-gray-500" data-id="element-27" />}
              </button>
              {openIndex === index && <div className="px-6 py-4 bg-white border-t border-gray-200" data-id="element-28">
                  <p className="text-gray-600" data-id="element-29">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
};